/* Componente reutilizable para incrustar en apps cliente de Sistemic.
   Requiere: CSS de .nm-svg / .nm-* en tu global CSS (ver BRAND.md). */

export function NodeMark({ size = 14 }: { size?: number }) {
  const C  = "oklch(0.58 0.22 250)";
  const Cd = "oklch(0.58 0.22 250/0.45)";
  return (
    <svg width={size} height={size} viewBox="0 0 26 26" fill="none" className="nm-svg">
      <rect x="8" y="8" width="10" height="10" fill={C} className="nm-square"
        style={{ transformBox: "fill-box", transformOrigin: "center" }} />
      <rect x="8" y="8" width="10" height="10" fill={C} className="nm-burst"
        style={{ transformBox: "fill-box", transformOrigin: "center" }} />
      <line x1="13" y1="8"  x2="13" y2="0"  stroke={C}  strokeWidth="1.8" className="nm-arm" style={{ animationDelay: ".65s" }} />
      <line x1="13" y1="18" x2="13" y2="26" stroke={Cd} strokeWidth="1.8" className="nm-arm" style={{ animationDelay: ".72s" }} />
      <line x1="8"  y1="13" x2="0"  y2="13" stroke={Cd} strokeWidth="1.8" className="nm-arm" style={{ animationDelay: ".79s" }} />
      <line x1="18" y1="13" x2="26" y2="13" stroke={C}  strokeWidth="1.8" className="nm-arm" style={{ animationDelay: ".86s" }} />
      <circle cx="13" cy="0"  r="2" fill={C}  className="nm-dot" style={{ animationDelay: "1.30s", transformBox: "fill-box", transformOrigin: "center" }} />
      <circle cx="26" cy="13" r="2" fill={C}  className="nm-dot" style={{ animationDelay: "1.38s", transformBox: "fill-box", transformOrigin: "center" }} />
      <circle cx="13" cy="26" r="2" fill={Cd} className="nm-dot" style={{ animationDelay: "1.46s", transformBox: "fill-box", transformOrigin: "center" }} />
      <circle cx="0"  cy="13" r="2" fill={Cd} className="nm-dot" style={{ animationDelay: "1.54s", transformBox: "fill-box", transformOrigin: "center" }} />
    </svg>
  );
}

export function PoweredBySistemic() {
  return (
    <a
      href="https://sistemic.vercel.app"
      target="_blank"
      rel="noopener noreferrer"
      style={{
        display: "inline-flex", alignItems: "center", gap: 7,
        textDecoration: "none",
        fontFamily: "'Space Grotesk', sans-serif",
        fontSize: 11, fontWeight: 600,
        letterSpacing: "0.12em", textTransform: "uppercase",
        color: "oklch(0.58 0.22 250 / 0.6)",
        transition: "color .2s",
      }}
      onMouseEnter={e => (e.currentTarget.style.color = "oklch(0.58 0.22 250)")}
      onMouseLeave={e => (e.currentTarget.style.color = "oklch(0.58 0.22 250 / 0.6)")}
    >
      <NodeMark size={14} />
      Hecho por Sistemic
    </a>
  );
}
